module.exports = __webpack_public_path__ + "img/avatar_13.12e3942a.svg";